import { Stack } from '@mui/material';
import { Button, Typography, colors } from '@sweep-io/sweep-design';

interface ArtifactsEmptyStateProps {
  isFiltered: boolean;
  onCreateClick: () => void;
  title: string;
  subtitle: string;
  buttonText?: string;
}

export const ArtifactsEmptyState = ({
  isFiltered,
  onCreateClick,
  title,
  subtitle,
  buttonText,
}: ArtifactsEmptyStateProps) => {
  // When filtered with no results, show standard message
  const displayTitle = isFiltered ? 'No results found' : title;
  const displaySubtitle = isFiltered ? 'Try changing your filters or search term' : subtitle;
  const showButton = !isFiltered && !!buttonText;

  return (
    <Stack height="100%" justifyContent="center" alignItems="center" gap={2}>
      <Typography variant="h3-medium" color={colors.grey[800]}>
        {displayTitle}
      </Typography>
      <Typography variant="body" color={colors.grey[700]}>
        {displaySubtitle}
      </Typography>
      {showButton && (
        <Button startIconName="Plus" size="small" onClick={onCreateClick}>
          {buttonText}
        </Button>
      )}
    </Stack>
  );
};
